export default{
  // setMessage(state,payload) {
  //   //state.messages.push(payload);
  //   //배열 합치기
  //   //state.messages.push(...payload);
  // },
  setFriendInit(state,payload) {
    //state.messages.push(payload);
    //배열 합치기
    state.friends = payload;
  },
  setRecommendInit(state,payload) {
    //state.messages.push(payload);
    //배열 합치기
    state.recommenders = payload;
  },
  setMessageCount(state,payload) {
    //state.messages.push(payload);
    //배열 합치기
    state.newMessage = payload;
  },
  deleteMessage(state, payload) {
    //게시글 삭제후 해당값 삭제
    if(state.messages)
    {
      const findItem = state.messages.find((msg)=>msg.id === payload);
      const idx = state.messages.indexOf(findItem);
      state.messages.splice(idx,1);
    }
  },
};
